import type { FC, SVGProps } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { SettingsRoutes } from 'app/application/types'

import { MenuItem } from 'components'

import styles from './SettingsMenu.module.scss'

export interface SettingsMenuItem {
  icon: FC<SVGProps<SVGSVGElement>>
  key: SettingsRoutes
}

interface SettingsMenuProps {
  activeRoute: SettingsRoutes
  items: SettingsMenuItem[]
  title: string
}

const SettingsMenu = ({ activeRoute, items, title }: SettingsMenuProps) => {
  const { t } = useTranslation('settings')
  const location = useLocation()

  return (
    <section className={styles.menuGroup}>
      <h2>{title}</h2>
      <ul>
        {items.map(({ icon, key }) => (
          <li key={key}>
            <MenuItem
              className={activeRoute === key ? styles.activeItem : undefined}
              icon={icon}
              label={t(`menu.${key}`)}
              selected={activeRoute === key}
              state={location.state as unknown}
              to={`/settings/${key}`}
            />
          </li>
        ))}
      </ul>
    </section>
  )
}

export default SettingsMenu
